import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const EventDetailsSection = ({ formData, set, orderTypeLabel }) => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-charcoal-ink border-b border-stone-taupe/20 pb-2">SECTION 2: EVENT DETAILS</h3>

    <div>
      <Label htmlFor="eventType" className="text-charcoal-ink">Type of Event *</Label>
      <select
        id="eventType"
        required
        value={formData.eventType}
        onChange={(e) => set('eventType', e.target.value)}
        className="w-full px-3 py-2 bg-white border border-stone-taupe/20 rounded-md text-charcoal-ink"
      >
        <option value="">Select event type</option>
        <option value="birthday">Birthday</option>
        <option value="wedding">Wedding</option>
        <option value="baby-shower">Baby Shower</option>
        <option value="bridal-shower">Bridal Shower</option>
        <option value="bachelorette">Bachelorette Party</option>
        <option value="graduation">Graduation</option>
        <option value="holiday">Holiday / Seasonal</option>
        <option value="other">Other</option>
      </select>
    </div>

    <div>
      <Label htmlFor="eventDate" className="text-charcoal-ink">When are these items needed by? *</Label>
      <Input
        id="eventDate"
        type="date"
        required
        value={formData.eventDate}
        onChange={(e) => set('eventDate', e.target.value)}
        className="bg-white border-stone-taupe/20"
      />
    </div>

    <div className="bg-soft-linen p-4 rounded-lg border border-stone-taupe/20" data-testid="order-type-display">
      <p className="text-sm text-stone-taupe">Order Type</p>
      <p className="text-charcoal-ink font-medium">You selected: {orderTypeLabel}</p>
    </div>
  </div>
);
